import React, { useEffect, useState } from 'react'
import Button from '../inputs/button'
import { useLocation } from 'react-router-dom';
import SubMenuItem from './subMenuItem';

function SidebarItem({ title, icon, path, subMenu }) {
    const [isOpen, setIsOpen] = useState(false)
    const location = useLocation();
    const handleClickSidebar = () => {
        setIsOpen(true);
    }
    const closeSidebarItem = () => {
        setIsOpen(false)
    }

    useEffect(() => {
        document.addEventListener("mousedown", closeSidebarItem);
        return () => document.removeEventListener("mousedown", closeSidebarItem);
    }, []);

    const GenerateDropList = () => {
        return (
            <ul className="submenu">
                {subMenu.map((item, index) => {
                    return (
                        <SubMenuItem key={index} title={item.title} path={item.path} />
                    )
                })}
            </ul>
        )
    }
    return (
        <li className={`sidebar-item  with-submenu ${(location.pathname == path || isOpen) ? 'active' : ''}`}>
            <a className='link' onClick={handleClickSidebar} >
                <span className="icon">{icon}</span>
                <span className='title'>{title}</span>
            </a>
            <div className="submenu">
                {GenerateDropList()}
            </div>
        </li>
    )
}

export default SidebarItem